import React, { useState, useEffect } from 'react'
import { PageHeader, Button, Table, Skeleton, Popconfirm, Modal } from 'antd'
import { useQuery } from '@apollo/react-hooks'
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons'

import ResultError from '@packages/ResultError'
import { APPLICATION_TYPES_ICON } from '@constants/IconsConstants'
import { useColumnFilterProps } from '@utils/columnFilter'
import { getApplicationTypesQuery } from '@graphql/queries'
import { useUpdateApplicationType, useDeleteApplicationType } from '@graphql/mutations'

import EditableCell from '../../EditableCell'
import ManageApplicationTypeForm from '../ManageApplicationTypeForm'

const tableProps = {
  size: 'middle',
  pagination: false,
}
const newButtonProps = {
  type: 'primary',
  icon: <PlusOutlined />,
  key: 'newApplicationType',
}

function ManageApplicationTypeTable() {
  const [applicationTypesData, setApplicationTypesData] = useState(false)
  const [formModalVisible, setFormModalVisible] = useState(false)
  const { error, data } = useQuery(getApplicationTypesQuery)
  const [updateApplicationType] = useUpdateApplicationType()
  const [deleteApplicationType] = useDeleteApplicationType()
  const useFilterField = field => useColumnFilterProps(field)
  const toggleFormModal = () => setFormModalVisible(!formModalVisible)

  useEffect(() => {
    if (data) setApplicationTypesData(data.applicationTypes)
  }, [data])

  const handleSave = data => {
    const { id, name } = data
    const newData = [...applicationTypesData]
    const index = newData.findIndex(item => item.id === data.id)
    const item = newData[index]

    newData.splice(index, 1, { ...item, ...data })

    if (JSON.stringify(newData) !== JSON.stringify(applicationTypesData)) {
      updateApplicationType({
        variables: {
          id,
          data: {
            name: { set: name },
          },
        },
      })

      setApplicationTypesData(newData)
    }
  }

  const handleDelete = id => {
    deleteApplicationType({
      variables: { id },
      refetchQueries: ['GetApplicationTypesQuery'],
    })
  }
  const columns = [
    {
      dataIndex: 'name',
      title: 'Nome',
      editable: true,
      ...useFilterField('name'),
    },
    {
      align: 'center',
      render: (value, { id, name }) => (
        <Popconfirm
          title={`Tem a certeza que quer eliminar ${name} ?`}
          onConfirm={() => handleDelete(id)}
          okText="Sim"
          cancelText="Não"
        >
          <DeleteOutlined />
        </Popconfirm>
      ),
    },
  ]
  const mappedColumns = columns.map(col => {
    if (!col.editable) return col

    return {
      ...col,
      onCell: record => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        handleSave,
      }),
    }
  })

  return (
    <>
      <Modal
        title="Novo tipo de aplicação"
        visible={formModalVisible}
        onCancel={() => toggleFormModal()}
        footer={null}
      >
        <ManageApplicationTypeForm afterSubmit={() => toggleFormModal()} />
      </Modal>

      <PageHeader
        title="Tipos de Aplicação"
        avatar={{ src: APPLICATION_TYPES_ICON }}
        extra={[
          <Button {...newButtonProps} onClick={() => toggleFormModal()}>
            Novo tipo de aplicação
          </Button>,
        ]}
      />

      {error && <ResultError />}

      <Skeleton loading={!error && !applicationTypesData} active>
        {applicationTypesData && (
          <Table
            components={EditableCell.Components}
            columns={mappedColumns}
            dataSource={applicationTypesData}
            rowKey={({ id }) => id}
            rowClassName={() => 'editable-row'}
            {...tableProps}
          />
        )}
      </Skeleton>
    </>
  )
}

export default ManageApplicationTypeTable
